import { default as FEATURES } from './feature-enum';
import { default as USER_CLAIMS } from './claim-enum';

const _mapUser = (user) => {
	if (user && user.hasOwnProperty('WebUsername')) {
		user.UserName = user.WebUsername || user.UserName;
	}

	return user;
};

const _retrieve = (itemName) => {
	var item = localStorage.getItem(itemName);

	if (item && ((item.indexOf('{') > -1 && item.indexOf('http') == -1) || item.indexOf('[') > -1)) {
		item = JSON.parse(item);
	}
	if (itemName === 'userProfile') {
		_mapUser(item);
	}

	return item;
};

const _isAuthorized = (claim) => {

	if (claim == "Trustee Dashboard") {
		return true;
    }

	if (!!!claim) {
		return false;
	}

	claim = claim.toLowerCase();
	let shouldAuthorize = false;

	const userProfile = _retrieve('userProfile');
	let selectedBuildingRef = _retrieve('selectedBuildingRef');

	if (!!!selectedBuildingRef && !!userProfile) {
		if (!!userProfile.BuildingProfiles && userProfile.BuildingProfiles.length > 0) {
			selectedBuildingRef = userProfile.BuildingProfiles[0].SchemeReference;
		}
	}

	if (selectedBuildingRef && userProfile) {
		if (typeof selectedBuildingRef === 'object') {
			selectedBuildingRef = selectedBuildingRef.SchemeReference;
		}

		if (selectedBuildingRef) {
			const selectedBuilding = userProfile.BuildingProfiles.find((buildingProf) => {
				const buildingRef = buildingProf.SchemeReference.toLowerCase().trim();
				if (buildingRef === selectedBuildingRef.toLowerCase().trim()) {
					return true;
				}
			});

			if (selectedBuilding) {
				const hasClaim = selectedBuilding.BuildingClaimMapped.find((desc) => {
                    const results = desc.Description.toLowerCase().trim() === claim.toLowerCase().trim();
                    return results;
                });
 
                if (!hasClaim) {
                    const owner = selectedBuilding.Role.find((role) => role.toLowerCase() === 'owner');
                    if (!!owner && capitalize(claim) === USER_CLAIMS.VIEW_PERSONAL_DOCUMENTS) {
                        shouldAuthorize = true;
                    }
                } else {
                    if (
						(
							hasClaim.Description.toLowerCase().trim() === USER_CLAIMS.MY_PROFILE.toLowerCase().trim() ||
							hasClaim.Description.toLowerCase().trim() === USER_CLAIMS.REGISTER_TENANT.toLowerCase().trim()	
						) &&
                        selectedBuilding.BuildingProfileUnit.filter((unit) => {
							return !unit.CardCode.includes('9999');
						  }).length == 0) {
                        shouldAuthorize = false;
                    }
                    else{
                        shouldAuthorize = !!hasClaim;
                    }
                }
			}
		}
	}

	return shouldAuthorize;
};

export const mapPageToFeature = (page) => {
	let feature;
	page = capitalize(page);

	switch (page) {
		case USER_CLAIMS.MY_PROFILE:
			feature = FEATURES.MY_PROFILE;
			break;
		case USER_CLAIMS.VIEW_LEVY_ROLL:
			feature = FEATURES.LEVY_ROLL;
			break;
		case USER_CLAIMS.VIEW_PAYMENTS:
			feature = FEATURES.PAYMENTS;
			break;
		case USER_CLAIMS.REGISTER_TENANT:
			feature = FEATURES.TENANT;
			break;
		case USER_CLAIMS.VIEW_FIRE_COMPLIANCE:
			feature = FEATURES.COMPLIANCE;
			break;
		case USER_CLAIMS.VIEW_ACCOUNTS_HISTORY:
			feature = FEATURES.ACCOUNT_HISTORY;
			break;
		case USER_CLAIMS.VIEW_BALANCE_SHEET:
			feature = FEATURES.BALANCE_SHEET;
			break;
		case USER_CLAIMS.VIEW_BUILDING_DOCUMENTS:
			feature = FEATURES.DOCUMENTS;
			break;
		case USER_CLAIMS.VIEW_CASHFLOW_STATEMENT:
			feature = FEATURES.CASHFLOW_STATEMENT;
			break;
		case USER_CLAIMS.VIEW_CASHFLOW_STATEMENT_NEW:
			feature = FEATURES.CASHFLOW_STATEMENT_NEW;
			break;
		case USER_CLAIMS.VIEW_CONTRACTORS_ROLL:
			feature = FEATURES.CONTRACTORS_ROLL;
			break;
		case USER_CLAIMS.VIEW_FINANCIALS:
			feature = FEATURES.FINANCIAL_SUMMARY;
			break;
		case USER_CLAIMS.VIEW_INCOME_STATEMENT:
			feature = FEATURES.INCOME_STATEMENT;
			break;
		case USER_CLAIMS.VIEW_INCOME_VS_BUDGET:
			feature = FEATURES.INCOME_VS_BUDGET;
			break;
		case USER_CLAIMS.VIEW_PAYMENT_BANDS:
		case USER_CLAIMS.VIEW_CONTRACTUAL_PAYMENTS:
			feature = FEATURES.PAYMENT_AUTHORISATION;
			break;
		case USER_CLAIMS.VIEW_PERSONAL_DOCUMENTS:
			feature = FEATURES.PERSONAL_DOCUMENTS;
			break;
		case USER_CLAIMS.APPROVE_PAYMENTS:
			feature = FEATURES.PAYMENTS;
			break;
		case USER_CLAIMS.QUERY_FIRE_QUOTE_COMPLIANCE:
		case USER_CLAIMS.APPROVE_MINI_SUB_QUOTE_COMPLIANCE:
			feature = FEATURES.COMPLIANCE;
			break;
		case USER_CLAIMS.UTILITY:
			feature = FEATURES.UTILITY;
            break;
        case USER_CLAIMS.VIEW_DOCUMENTS_APPROVAL:
            feature = FEATURES.DOCUMENTS_APPROVAL;
            break;
        case USER_CLAIMS.VIEW_WAGES_ROLL:
            feature = FEATURES.WAGES_ROLL;
			break;
		case USER_CLAIMS.TRUSTEE_DASHBOARD:
			feature = FEATURES.TRUSTEE_DASHBOARD;
			break;
		case USER_CLAIMS.DEBTOR_AGE_ANALYSIS:
			feature = FEATURES.DEBTOR_AGE_ANALYSIS;
			break;
		case USER_CLAIMS.SHOW_FIND_A_CONTRACTOR:
			feature = FEATURES.SHOW_FIND_A_CONTRACTOR;
			break;
	}

	return feature;
};

export const capitalize = (text) => {
	if (!!!text) {
		return text;
	}

	let mapped;
	const fields = text.split(' ');
	const transformed = fields.map((val) => {
		let newText = `${val.substr(0, 1).toUpperCase()}${val.substr(1, val.length - 1).toLowerCase()}`;
		return newText;
	});

	mapped = transformed.join(' ');
	return mapped;
};

/**
 * Checks if a feature should be enabled
 * 
 * @param {any} page 
 * @param {any} featureSettings 
 * 
 * @memberOf MainCtrl
 */
export const checkIfFeatureIsEnable = (page, featureSettings) => {
	let isFeatureEnabled = false;

	if (!!!featureSettings) {
		return isFeatureEnabled;
	}

	switch (page) {
		case FEATURES.DOCUMENTS:
		case FEATURES.COMPLIANCE:
			isFeatureEnabled = true;
			break;
		case FEATURES.LEVY_ROLL:
			const { LevyRoll: levyRoll } = featureSettings;
			isFeatureEnabled = levyRoll;
			break;
		case FEATURES.MY_PROFILE:
			const { MyProfile: myProfile } = featureSettings;
			isFeatureEnabled = myProfile;
			break;
		case FEATURES.FINANCIAL_SUMMARY:
			const { Financials: financials } = featureSettings;
			isFeatureEnabled = financials;
			break;
		case FEATURES.BALANCE_SHEET:
			const { BalanceSheet: balanceSheet } = featureSettings;
			isFeatureEnabled = balanceSheet;
			break;
		case FEATURES.TENANT:
			const { RegisterTenant: registerTenant } = featureSettings;
			isFeatureEnabled = registerTenant;
			break;
		case FEATURES.CONTRACTORS_ROLL:
			const { ContractorsRoll: contractorsRoll } = featureSettings;
			isFeatureEnabled = contractorsRoll;
			break;
		case FEATURES.INCOME_STATEMENT:
			const { IncomeStatement: incomeStatement } = featureSettings;
			isFeatureEnabled = incomeStatement;
			break;
		case FEATURES.PAYMENTS:
			const { Payments: payments } = featureSettings;
			isFeatureEnabled = payments;
			break;
		case FEATURES.PERSONAL_DOCUMENTS:
			const { PersonalDocuments: personalDocuments } = featureSettings;
			isFeatureEnabled = personalDocuments;
			break;
		case FEATURES.DASHBOARD:
			const { IsDashboardEnabled: isDashboardEnabled } = featureSettings;
			isFeatureEnabled = isDashboardEnabled;
			break;
		case FEATURES.ACCOUNT_HISTORY:
			const { ViewAccountHistory: viewAccountHistory } = featureSettings;
			isFeatureEnabled = viewAccountHistory;
			break;
		case FEATURES.PAYMENT_AUTHORISATION:
			const { PaymentAuthorisations: paymentAuthorisations } = featureSettings;
			isFeatureEnabled = paymentAuthorisations;
			break;
		case FEATURES.CASHFLOW_STATEMENT:
			const { CashflowStatement: cashflowStatement } = featureSettings;
			isFeatureEnabled = cashflowStatement;
			break;
		case FEATURES.UTILITY:
			const { MyProfile: utility } = featureSettings;
			isFeatureEnabled = utility;
            break;
        case FEATURES.DOCUMENTS_APPROVAL:
            const { ViewDocumentsApproval: viewDocumentsApproval } = featureSettings;
            isFeatureEnabled = viewDocumentsApproval;
            break;
        case FEATURES.WAGES_ROLL:
            const { WagesRoll: wagesRoll } = featureSettings;
            isFeatureEnabled = wagesRoll;
			break;
		case FEATURES.TRUSTEE_DASHBOARD:
			const { TrusteeDashboard: trusteeDashboard } = featureSettings;
			isFeatureEnabled = true;
			break;
		case FEATURES.CASHFLOW_STATEMENT_NEW:
			const { CashflowStatementNew: cashflowStatementNew } = featureSettings;
			isFeatureEnabled = cashflowStatementNew;
			break;
		case FEATURES.INCOME_VS_BUDGET:
			const { IncomeVSBudget: incomeVSBudget } = featureSettings;
			isFeatureEnabled = incomeVSBudget;
			break;
		case FEATURES.DEBTOR_AGE_ANALYSIS:
			const { DebtorAgeAnalysis: debtorAgeAnalysis } = featureSettings;
			isFeatureEnabled = debtorAgeAnalysis;
			break;
		case FEATURES.SHOW_FIND_A_CONTRACTOR:
			const { ShowContractor: showContractor } = featureSettings;
			isFeatureEnabled = showContractor;
			break;
	}

	return isFeatureEnabled;
};

export const shouldBeEnabled = (page, alsoCheckDashboard = false) => {
	let isEnabled = false;
	const claim = mapPageToFeature(page);
	const isUserAuthorized = _isAuthorized(page);
	if (isUserAuthorized) {
		let buildingRef = _retrieve('selectedBuildingRef');
		buildingRef = !!buildingRef && typeof buildingRef === 'object' ? buildingRef.SchemeReference : buildingRef;

		if (!!buildingRef) {
			let featureSettings;
			const buildingsFeatures = _retrieve('buildingsFeatures');
			if (!!buildingsFeatures) {
				featureSettings = buildingsFeatures[buildingRef];
			} else {
				return false;
			}

			isEnabled = checkIfFeatureIsEnable(claim, featureSettings);

			let isDashboardEnabled = false;
			if (!!featureSettings) {
				const { IsDashboardEnabled } = featureSettings;
				isDashboardEnabled = IsDashboardEnabled;
			}
			
			return alsoCheckDashboard ? isEnabled && isDashboardEnabled : isEnabled;
		}
		return isUserAuthorized;
	} else {
		return false;
	}
};

export const canPerformAction = (action, schemeRef) => {
	let userHasRights = false;
	const isUserAuthorized = _isAuthorized(action);

	if (isUserAuthorized) {
		let buildingRef = schemeRef ? schemeRef : _retrieve('selectedBuildingRef');
		buildingRef = !!buildingRef && typeof buildingRef === 'object' ? buildingRef.SchemeReference : buildingRef;

		if (!!buildingRef) {
			let featureSettings;
			const buildingsFeatures = _retrieve('buildingsFeatures');
			if (!!buildingsFeatures) {
				featureSettings = buildingsFeatures[buildingRef];
			} else {
				return false;
			}

			if (!!!featureSettings) {
				return false;
			}

			switch (capitalize(action)) {
				case USER_CLAIMS.APPROVE_PAYMENTS:
					const { PaymentsApproval: paymentsApproval } = featureSettings;
					userHasRights = paymentsApproval;
					break;
			}

			return userHasRights;
		}
		return userHasRights;
	}

	return userHasRights;
};

export const serverfyJSObject = (original) => {
	if (!!!original) return null;
	let mappedObject = {};

	Object.keys(original).map((key) => {
		const temp = original[key];
		delete original[key];
		const newKey = `${key.substr(0, 1).toUpperCase()}${key.substr(1)}`;
		mappedObject[newKey] = temp;
	});

	return mappedObject;
};
